'use client'

import type { JSX } from "react";
import Script from 'next/script'

export function GoogleAnalytics(): JSX.Element | null {
  const measurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID?.trim()

  if (!measurementId) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[GA4] NEXT_PUBLIC_GA_MEASUREMENT_ID is not set. Google Analytics will not be initialized.')
    }
    return null
  }

  // Validate measurement ID format (should start with G-)
  if (!measurementId.startsWith('G-')) {
    console.error(`[GA4] Invalid measurement ID format: ${measurementId}. Expected format: G-XXXXXXXXXX`)
    return null
  }

  if (process.env.NODE_ENV === 'development') {
    console.log(`[GA4] Initializing with measurement ID: ${measurementId}`)
  }

  return (
    <>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
        onLoad={() => {
          if (process.env.NODE_ENV === 'development') {
            console.log('[GA4] gtag.js script loaded successfully')
          }
        }}
        onError={() => {
          if (process.env.NODE_ENV === 'development') {
            console.warn(
              `[GA4] Failed to load gtag.js script for measurement ID: ${measurementId}\n` +
              `This is common in local development and usually caused by:\n` +
              `- Ad blockers (uBlock Origin, AdBlock Plus, etc.)\n` +
              `- Browser privacy extensions\n` +
              `- Network restrictions\n\n` +
              `Google Analytics will work correctly in production when these blockers are not active.`
            )
          } else {
            console.error(`[GA4] Failed to load gtag.js script for measurement ID: ${measurementId}`)
          }
        }}
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: [
            'window.dataLayer = window.dataLayer || [];',
            'function gtag(){dataLayer.push(arguments);}',
            "gtag('js', new Date());",
            "gtag('consent', 'default', {'analytics_storage': 'denied', 'ad_storage': 'denied'});",
            `gtag('config', ${JSON.stringify(measurementId)}, {page_path: window.location.pathname});`,
          ].join('')
        }}
      />
    </>
  )
}
